import { get, isPlainObject } from 'lodash';

import { GLOBAL_FIELD_ANCHOR } from '~/components/SystemConfiguration/GlobalConfiguration/types';

const GLOBAL_FIELD_TAG = 'global_field_id';
const IS_GLOBAL_KEY = 'is_global';
const GLOBAL_ANCHOR_KEY = 'global_anchor';

// Mirrors the backend's `is_global_entry`: a projected entry carries both markers and either one marks
// it. `is_global` is matched on its value, so a local field sent back with `is_global: false` stays
// local; `global_field_id` on its presence, because no local field carries that key at all.
export const isGlobalEntry = (entry: unknown): boolean =>
  isPlainObject(entry) &&
  (GLOBAL_FIELD_TAG in (entry as object) || (entry as Record<string, unknown>)[IS_GLOBAL_KEY] === true);

export interface SectionIndexPartition {
  startIndexes: number[];
  localIndexes: number[];
  endIndexes: number[];
}

// The projection stamps each entry with the anchor it was written at, so a global stays in its block
// whatever own fields are added or dragged around it. An entry projected before the anchor was stamped
// reads as start-anchored; the configuration GET reports it as stale, and Fix and reload re-stamps it.
const isEndAnchored = (entry: unknown): boolean => get(entry, GLOBAL_ANCHOR_KEY) === GLOBAL_FIELD_ANCHOR.End;

export const partitionSectionIndexes = (fields: unknown[], sectionIndexes: number[]): SectionIndexPartition => {
  const isGlobalAt = (index: number) => isGlobalEntry(fields[index]);
  const isEndAt = (index: number) => isEndAnchored(fields[index]);
  return {
    startIndexes: sectionIndexes.filter((index) => isGlobalAt(index) && !isEndAt(index)),
    localIndexes: sectionIndexes.filter((index) => !isGlobalAt(index)),
    endIndexes: sectionIndexes.filter((index) => isGlobalAt(index) && isEndAt(index)),
  };
};
